import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component SortListIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <SortListIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <SortListIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SortListIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={18}
      data-testid="SortListIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m16 0 4 4h-3v10h3l-4 4-4-4h3V4h-3zM9 13a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zm3-5a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2zM9 3a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2z"
        clipRule="evenodd"
      />
    </svg>
  )
);
SortListIcon.displayName = "SortListIcon";
export default SortListIcon;
